export function compare(array, otherArray) {
  if (array.length !== otherArray.length) return false;

  for (var i = 0; i < otherArray.length; i++) {
    if (array[i].compare) {
      if (!array[i].compare(otherArray[i])) return false;
    } else if (array[i] !== otherArray[i]) {
      return false;
    }
  }
  return true;
}
